import { Button } from "@/components/ui/button";

const FinalCTA = () => {
  return (
    <section className="py-32 px-4 bg-primary text-primary-foreground">
      <div className="container mx-auto max-w-4xl space-y-8">
        <h2 className="text-4xl md:text-6xl font-black leading-tight text-primary-foreground">
          Building in AI infrastructure, sovereign or physical AI?
        </h2>
        <p className="text-xl text-primary-foreground/90 leading-relaxed border-l-4 border-accent pl-6">
          Send us what you're building and where you're stuck. We read everything.
        </p>
        <Button size="lg" variant="default" className="text-lg h-14 px-10 font-bold" asChild>
          <a href="mailto:arun@amx.ventures">Pitch AMX</a>
        </Button>
      </div>
    </section>
  );
};

export default FinalCTA;